/**
 * @generated SignedSource<<534a09a936f3a66097ae4f55b2754466>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SessionsForm_InterviewSlotEditor_slot$data = {
  readonly countOfBookedSlots: number | null;
  readonly " $fragmentSpreads": FragmentRefs<"InputSlotDetails_slot">;
  readonly " $fragmentType": "SessionsForm_InterviewSlotEditor_slot";
};
export type SessionsForm_InterviewSlotEditor_slot$key = {
  readonly " $data"?: SessionsForm_InterviewSlotEditor_slot$data;
  readonly " $fragmentSpreads": FragmentRefs<"SessionsForm_InterviewSlotEditor_slot">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SessionsForm_InterviewSlotEditor_slot",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "countOfBookedSlots",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "InputSlotDetails_slot"
    }
  ],
  "type": "StudyAvailabilitySlotNode",
  "abstractKey": null
};

(node as any).hash = "fec0428a26d49e8394275c6d62e5f697";

export default node;
